<template>
  <img class="currency-icon" :src="dataUri" :alt="name" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { createAvatar } from '@dicebear/core'
import { identicon } from '@dicebear/collection'
import {
  getSystemTintColorsHex,
  getColorFromCss,
  cssColorToHex,
} from '@/helpers/colors'

const SHAPE_RENDERING_ATTRIBUTE = 'shape-rendering="crispEdges"'

const props = defineProps<{
  name: string
  symbol: string
}>()

const dataUri = computed(() => {
  const svg = createAvatar(identicon, {
    seed: `${props.name} | ${props.symbol}`,
    flip: false,
    rotate: 30,
    scale: 180,
    radius: 50,
    backgroundType: ['solid'],
    backgroundColor: [cssColorToHex(getColorFromCss('--color-outline'))],
    row2: ['ooxoo', 'oxoxo', 'oxxxo'],
    row3: ['ooxoo', 'oxoxo'],
    row4: ['ooxoo', 'oxoxo', 'oxxxo'],
    rowColor: getSystemTintColorsHex(),
  }).toString()

  return `data:image/svg+xml;utf8,${encodeURIComponent(
    svg.replace(SHAPE_RENDERING_ATTRIBUTE, 'shape-rendering="auto"')
  )}`
})
</script>
